import { container } from '@hub-la/fe-container'
import { TelegramVerificationProvider, VerificationStartPage } from '@hub-la/fe-telegram-verification'
import { withRoleplayRedirect } from '../components/roleplay-redirect'

export const TelegramVerificationStartInit = withRoleplayRedirect(() => {
  return (
    <TelegramVerificationProvider container={container}>
      <VerificationStartPage />
    </TelegramVerificationProvider>
  )
})
